module.exports = __webpack_public_path__ + "img/mgh-gotanda-sp.126facd7.jpg";